import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import Baseindex from "../About/base";
import imageK from "../../assets/image4.png";
import Page from "./page";
import { Link, animateScroll as scroll } from "react-scroll";
// import Section from "./Section";
import WhitePaper from "./whitepaper";
import Demo from "./demo";
import Gs from "./gs";
import Ebook from "./ebook";
export default function LibraryIndex() {
  const [isShown, setIsShown] = useState("WhitePaper");

  const handleClick = (event, param) => {
    // console.log(param);
    setIsShown(param);
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <div className="container flex items-center  h-[80vh] mx-auto justify-evenly firstPage">
        <div
          data-aos="zoom-out"
          data-aos-duration="1000"
          className="flex flex-col px-6 py-6"
        >
          <h1 className="p-4 text-5xl font-semibold text-white">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#E975A8] to-[#726CF8]">
              RESOURCES LIBRARY
            </span>
          </h1>
          <div className="p-4 text-[#BBBBBB] flex flex-col items-stretch">
            <span className="">
              {" "}
              SUBCRIBE TO GET UPDATE ABOUT OUR NEWSLETTER, E-
            </span>
            <span className="self-center">BOOKS, DEMOS, AND BLOG.</span>
          </div>
          <div className="flex flex-row p-4">
            <input
              placeholder="Enter your email adress"
              className="rounded h-12 w-11/12 bg-neutral-500 placeholder:text-white  placeholder:pl-4"
            />
            <button className="text-[#ffffff] bg-gradient-to-r from-[#E975A8] to-[#726CF8] px-3 py-3 ml-4 rounded w-3/12">
              Send
            </button>
          </div>
        </div>

        <motion.div
          initial={{ motionRotation: 0 }}
          viewport={{ margin: -"40px" }}
          animate={{ rotate: 360 }}
          transition={{
            duration: 4.5,
            repeat: Infinity,
            restSpeed: 0.01,
            repeatType: "mirror",
          }}
        >
          <div className="w-[390px] hover:cursor-grab firstPageImg">
            <img src={imageK} alt="" />
          </div>
        </motion.div>
      </div>

      <div className="flex flex-row justify-between p-10 w-full">
        <div className="bg-black-rgba p-1 mr-2">
          <button
            className="text-[#ffffff] hover:bg-gradient-to-r  hover:from-[#E975A8]  hover:to-[#726CF8] px-3 py-3"
            onClick={(event) => handleClick(event, "WhitePaper")}
          >
            White paper
          </button>
        </div>
        <div className="bg-black-rgba p-1   mr-2">
          <button
            className="text-[#ffffff] hover:bg-gradient-to-r  hover:from-[#E975A8]  hover:to-[#726CF8] px-3 py-3"
            onClick={(event) => handleClick(event, "GS")}
          >
            Getting started
          </button>
        </div>
        <div className="bg-black-rgba p-1  mr-2">
          <button
            className="text-[#ffffff] hover:bg-gradient-to-r  hover:from-[#E975A8]  hover:to-[#726CF8] px-3 py-3"
            onClick={(event) => handleClick(event, "Demo")}
          >
            Demo and Video
          </button>
        </div>
        <div className="bg-black-rgba p-1  mr-2">
          <button
            className="text-[#ffffff] hover:bg-gradient-to-r  hover:from-[#E975A8]  hover:to-[#726CF8] px-3 py-3"
            onClick={(event) => handleClick(event, "ebook")}
          >
            E-books
          </button>
        </div>
      </div>
      {isShown == "WhitePaper" && <WhitePaper />}
      {isShown == "GS" && <Gs />}
      {isShown == "Demo" && <Demo />}
      {isShown == "ebook" && <Ebook />}
      <div className="pl-24 pr-24 content-start flex-col  p-4 justify-center  flex">
        <Baseindex />
      </div>
    </>
  );
}
